import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { MenuItemBase } from "../../../components/layout/navMenu";
import HubShortcutGrid from "./HubShortcutGrid";

interface HubOverviewSectionProps {
  shortcuts: MenuItemBase[];
  badges?: Record<string, number>;
  children: React.ReactNode;
}

const HubOverviewSection: React.FC<HubOverviewSectionProps> = ({
  shortcuts,
  badges,
  children,
}) => {
  const widgets = React.Children.toArray(children);

  return (
    <Box>
      {widgets.length > 0 && (
        <>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, mb: 1, fontSize: "0.8rem" }}
          >
            Current state
          </Typography>
          <Grid container spacing={1.25} sx={{ mb: 2.5 }}>
            {widgets}
          </Grid>
        </>
      )}
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 600, mb: 1, fontSize: "0.8rem" }}
      >
        Pages
      </Typography>
      <HubShortcutGrid shortcuts={shortcuts} badges={badges} />
    </Box>
  );
};

export default HubOverviewSection;
